import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import getUserDisplayInfo from 'library-@/utils/getUserDisplayInfo';
import getUserPostInfo from 'library-@/utils/getUserPostInfo';
import WorkspaceDropdown from './WorkspaceDropdown.vue';
//@ts-ignore
import { Dialog } from 'element-ui-2';
import { useI18n } from '../../composables/use-i18n';
import { ref, computed, watch } from 'vue';
import { useCommentScope } from './composables/use-comment-scope';

type Comment = {
    comment_text?: string;
    comment_to_info?: Record<string, unknown>;
    comment_by?: string;
    comment_id?: string;
    comment_to_id?: string;
    wording_id?: string;
    source?: string;
    visible_scope?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentTextarea',
  props: {
    comment: { default: () => ({}) },
    commentLength: { default: 0 },
    currentUser: { default: () => ({}) },
    maxLength: { default: 500 },
    showLimitInTextarea: { type: Boolean, default: false },
    sourceFrom: { default: 'WORKSPACE' },
    isPersonalAccount: { type: Boolean, default: false },
    sourceIn: { default: 'WORKSPACE' }
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'submit', data: { type: string, data: Comment }): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { comment: Comment, commentLength: number, currentUser: Record<string, unknown>, maxLength: number, showLimitInTextarea: boolean, sourceFrom: 'WORKSPACE' | 'ANALYTICS' | 'EUREKA' | 'VOTE', isPersonalAccount: boolean, sourceIn: 'WORKSPACE' | 'ANALYTICS' | 'EUREKA' | 'VOTE' }

const ElDialog = Dialog;

/**
 * 评论数据结构
 */


const { t } = useI18n();

const {
    supportedScopes,
    currentScope,
    changeCurrentScope,
    handleScopesWhenCommentChange,
    handleScopeWhenCommentChange,
} = useCommentScope();

const changeScopeDialogTitle = ref<string>('');

const changeScopeDialogContent = ref<string>('');

const showChangeScopeDialog = ref<boolean>(false);

const commentCopy = ref<Comment>({});

const commentLimit = computed(() => props.maxLength);

const commentTextLength = computed(() => {
    return _.get(commentCopy.value, 'comment_text.length') || 0;
});

const overMaxLength = computed(() => {
    return commentTextLength.value > commentLimit.value;
});

const isReplyMode = computed(() => {
    return !_.isEmpty(commentCopy.value.comment_to_info)
});

const placeholder = computed(() => {
    let placeholder = t('snapBusiness.comment.addComment');
    if (isReplyMode.value) {
        placeholder = `${t('snapBusiness.global.btn.reply')} ${getUserDisplayInfo(commentCopy.value.comment_to_info)}:`;
    }
    return placeholder;
});

function created() {
    if (props.commentLength === 0) {
        commentCopy.value.comment_by = getUserDisplayInfo(props.currentUser);
    }
}

created();



function handleSubmit(force: boolean = false) {
    const commentText = _.trim(_.get(commentCopy.value, 'comment_text'));
    if (commentText.length === 0 || commentText.length > commentLimit.value) return;
    if (commentCopy.value.comment_id) {
        const data = {
            comment_text: commentCopy.value.comment_text,
            comment_id: commentCopy.value.comment_id,
            comment_to: getUserPostInfo(commentCopy.value.comment_to_info),
            wording_id: commentCopy.value.wording_id,
            source: commentCopy.value.source,
            visible_scope: currentScope.value.key,
        };
        if (!force && commentCopy.value?.visible_scope !== currentScope.value.key && currentScope.value.key !== 'SPACE') {
            changeScopeDialogTitle.value = currentScope.value.key === 'ORG'
                ? 'snapBusiness.comment.changeCommentORG.title'
                : 'snapBusiness.comment.changeCommentPRV.title';
            changeScopeDialogContent.value = currentScope.value.key === 'ORG'
                ? 'snapBusiness.comment.changeCommentORG.content'
                : 'snapBusiness.comment.changeCommentPRV.content';
            showChangeScopeDialog.value = true;
            return;
        }
        emit('submit', { type: 'edit', data });
    } else {
        const data = {
            comment_text: commentCopy.value.comment_text,
            comment_to: getUserPostInfo(commentCopy.value.comment_to_info),
            comment_to_id: commentCopy.value.comment_to_id,
            wording_id: commentCopy.value.wording_id,
            source: commentCopy.value.source,
            visible_scope: isReplyMode.value
                ? commentCopy.value.visible_scope
                : currentScope.value.key,
        };
        emit('submit', { type: 'add', data });
    }
}

function handleEnter(e: KeyboardEvent) {
    // 输入法候选状态：Enter 仅用于选词，不触发提交
    // e.isComposing 为现代浏览器标准；keyCode === 229 兼容部分输入法回退
    if (e.isComposing || e.keyCode === 229) return;

    // Shift+Enter 走默认行为，textarea 自动换行
    if (e.shiftKey) return;

    // 纯 Enter：阻止默认换行，触发提交（复用 handleSubmit 内部空内容/超长校验）
    e.preventDefault();
    handleSubmit();
}

const commentTextarea = ref<HTMLTextAreaElement | null>(null);

function focusTextarea() {
    commentTextarea.value?.focus();
}

expose({
    focusTextarea,
});

function cancel() {
    emit('cancel');
}

function handleCommentChange(comment: { visible_scope?: string }) {
    handleScopesWhenCommentChange({
        sourceFrom: props.sourceFrom,
        isPersonal: props.isPersonalAccount,
    });
    handleScopeWhenCommentChange(comment);
    commentCopy.value = _.cloneDeep(comment);
}

watch(() => props.comment, handleCommentChange, { immediate: true, deep: true });

return { __sfc: true,ElDialog, props, t, supportedScopes, currentScope, changeCurrentScope, handleScopesWhenCommentChange, handleScopeWhenCommentChange, changeScopeDialogTitle, changeScopeDialogContent, showChangeScopeDialog, commentCopy, commentLimit, commentTextLength, overMaxLength, isReplyMode, placeholder, created, emit, handleSubmit, handleEnter, commentTextarea, focusTextarea, cancel, handleCommentChange, WorkspaceDropdown }
}

})